import { render, staticRenderFns } from "./LotListItemTitle.vue?vue&type=template&id=36a97ba6&scoped=true&"
import script from "./LotListItemTitle.vue?vue&type=script&lang=js&"
export * from "./LotListItemTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a97ba6",
  null
  
)

export default component.exports